import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Hiring from "./pages/Hiring";
import Services from "./pages/Services";
import Partners from "./pages/Partners";
import Lottie from "lottie-react";
import truckAnimation from "./assets/truckAnimation.json";
import Maintenance from "./pages/Maintennancosdc";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from "./config/scrolltotop";

const HomePage = React.lazy(() => import("./pages/HomePage"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Suspense
          fallback={
            <div
              style={{
                position: "fixed", // anchors it to the viewport
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 9999, // ensures it's above all other content
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#1b305a",
                color: "#fff",
                fontSize: "1.5rem",
              }}
            >
              <Lottie
                animationData={truckAnimation}
                loop
                autoplay
                style={{ height: "300px", width: "300px" }}
              />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/joinus" element={<Hiring />} />
            <Route path="/services" element={<Services />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/shipwithus" element={<Maintenance />} />
            <Route path="/truckrepair" element={<Maintenance />} />
            <Route path="/truckwash" element={<Maintenance />} />
            <Route path="/restacking" element={<Maintenance />} />
            <Route path="/roadsideservice" element={<Maintenance />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
